<template>
  <div>
    <b-row>
      <b-col>
        <h5 v-if="indicatorDescription.length > 0"><b-alert :variant="indicatorState" show class="m-auto">{{ indicatorDescription }}</b-alert></h5>
        <h5 v-else><b-alert variant="light" show class="m-auto" style="height: 2.4em;"></b-alert></h5>
      </b-col>
    </b-row>
    <b-row class="text-center" style="overflow:scroll; height: 75vh;">
      <b-col>
        <div>
          <div id="spreadsheetPerformance" ref="spreadsheetPerformance"></div>
        </div>
      </b-col>
    </b-row>
    <b-modal id="performanceIndicator" no-enforce-focus scrollable ref="modal" title="Información del indicador" hide-footer size="lg" @hidden="onHidden">
      <b-tabs content-class="mt-3">
        <b-tab title="Fortaleza" active><performance @indicator="recieveIndicator" indicatorName="fortaleza" :indicatorType="1" :doesSelect="true"></performance></b-tab>
        <b-tab title="Débilidades"><performance @indicator="recieveIndicator" indicatorName="débilidad" :indicatorType="2" :doesSelect="true"></performance></b-tab>
        <b-tab title="Recomendaciones"><performance @indicator="recieveIndicator" indicatorName="recomendación" :indicatorType="3" :doesSelect="true"></performance></b-tab>
      </b-tabs>
      <empty-table v-show="false" />
      <!-- <b-table v-show="indicator.length > 0" striped hover :fields="columns" :items="indicator" head-variant="light" responsive /> -->
    </b-modal>
    <b-modal id="observation" no-enforce-focus scrollable ref="modal" hide-header hide-footer size="md" @hidden="onHidden">
      <b-row class="my-3">
        <b-col sm="3">
          <label for="textarea-default">Observación:</label>
        </b-col>
        <b-col sm="9" class="pl-1">
          <b-form-textarea
            v-model="observation"
            id="textarea-default"
            maxlength="512"
            placeholder="Ingrese la Observación"
            rows="4"
          ></b-form-textarea>
        </b-col>
      </b-row>
      <b-row class="p-auto mr-3">
        <b-col>
          <b-button @click="saveObservation()" variant="primary" class="mb-3 mt-3">Guardar</b-button>
          <button @click="$bvModal.hide('observation')" class="btn mr-2 mb-3 mt-3 btn-light btn-sm">
            Cancelar
          </button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="inconsistences" no-enforce-focus scrollable ref="modal" title="Inconsistencias" hide-footer size="md" @hidden="onHidden">
      <b-row class="my-3">
        <b-col class="ml-3" v-for="(value, key) in inconsistences" v-bind:key="key.id" lg="15" md="15" sm="15">>
          {{ value[1] }} : {{ value[2] }}
        </b-col>
      </b-row>
      <b-row class="p-auto mr-3">
        <b-col>
          <b-button @click="$bvModal.hide('inconsistences')" variant="primary" class="mb-3 mt-3">Cerrar</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import apiClient from '@/services/axios'
import Swal from 'sweetalert2'
import jexcel from 'jexcel'
import performance from '@/components/custom/performance'
import emptyTable from '@/components/custom/cardEmptyList'
import { showErrorMessage } from '@/services/utilities'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  components: {
    emptyTable,
    performance,
  },
  name: 'performanceIndicator',
  props: {
    dataInfo: {
      type: Object,
    },
    isElective: {
      type: Boolean,
    },
    currentPeriod: {
      type: Number,
    },
    idClass: {
      type: Number,
    },
    teacherEditableView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var self = this
    return {
      indicatorVisible: false,
      indicator: [],
      columns: [
        { key: 'id', label: 'Código' },
        { key: 'description', label: '' },
      ],
      autoSave: true,
      typingTimer: '',
      isRecentChanges: false,
      tableLength: '',
      indicatorState: 'light',
      indicatorDescription: '',
      indicatorCorrect: false,
      observation: '',
      rowModal: {
        data: '',
        row: '',
      },
      inconsistences: [],
      jExcelObj: {},
      gradesExcel: {},
      options: {
        minDimensions: [11, 1],
        allowInsertRow: false,
        allowInsertColumn: false,
        onchange: self.changed,
        onload: self.loaded,
        onselection: self.selectionActive,
        onbeforechange: self.beforeChange,
        onafterchanges: self.afterchanges,
        oneditionend: self.resetFocus,
        allowDeleteRow: false,
        allowDeleteColumn: false,
        rowDrag: false,
        columnDrag: false,
        columnSorting: false,
        contextMenu: function (obj, x, y, e) {
          const items = []
          if (obj.options.allowExport) {
            items.push({
              title: obj.options.text.saveAs,
              shortcut: 'Ctrl + S',
              onclick: function () {
                obj.download()
              },
            })
          }
          if (obj.options.allowRenameColumn) {
            items.push({
              title: obj.options.text.renameThisColumn,
              onclick: function() {
                obj.setHeader(x)
              },
            })
          }
          return items
        },
      },
    }
  },
  created: function () {
  },
  mounted: function () {
    this.setDataIndicators(this.dataInfo)
  },
  updated: function () {
  },
  beforeDestroy: function () {
  },
  watch: {
    options: {
      handler: function (after, before) {
        console.log(after)
      },
      deep: true,
    },
  },
  methods: {
    onHidden (e) {
      this.rowModal.row = this.rowModal.data = ''
      this.observation = ''
      this.indicator = []
    },
    resetFocus (instance, xox, x, y, cell) {
      this.jExcelObj.updateSelectionFromCoords(x, y, x, y)
      this.jExcelObj.resetSelection(true)
    },
    selectionActive(instance, x, y, origin) {
      if (this.teacherEditableView) {
        if (x === 11) {
          this.rowModal.row = y
          this.rowModal.data = this.jExcelObj.getRowData(y)
          this.$bvModal.show('performanceIndicator')
        } else if (x === 12) {
          this.rowModal.row = y
          this.rowModal.data = this.jExcelObj.getRowData(y)
          for (const student of this.dataInfo.observationList) {
            if (student[0] === this.rowModal.data[0]) {
              this.observation = student[1]
            }
          }
          this.$bvModal.show('observation')
        } else if (x < 11 && x > 1) {
          const cellName1 = parseInt(this.jExcelObj.getValueFromCoords([x], [y])) ? parseInt(this.jExcelObj.getValueFromCoords([x], [y])) : 0
          if (cellName1 >= 1) {
            let type = ''
            if (x >= 2 && x <= 4) {
              type = 2
            } else if (x >= 5 && x <= 7) {
              type = 1
            } else if (x >= 8 && x <= 10) {
              type = 3
            }
            apiClient.get(`/performance-indicators/${cellName1}`, { params: { type: type, idClass: this.idClass, isElective: this.isElective } }).then(response => {
              this.indicatorState = response.data.indicatorState
              this.indicatorDescription = response.data.description
              this.indicatorCorrect = response.data.indicatorCorrect
              if (!this.indicatorCorrect) {
                this.jExcelObj.setValueFromCoords(x, y, '')
              }
            }).catch(error => {
              this.$notification.error({
                message: 'Ooops ocurrió un error',
                description: showErrorMessage(error),
              })
            })
          } else {
            this.indicatorState = 'light'
            this.indicatorDescription = ''
            this.indicatorCorrect = false
          }
        }
      } else {
        this.jExcelObj.setValueFromCoords(x, y, '')
        this.$notification.warning({
          message: 'Modificación no permitida',
          description: 'Directores de grupo no pueden modificar indicadores/observaciones.',
        })
      }
    },
    setDataIndicators(dataQualifications) {
      for (const student of dataQualifications.performanceList) {
        student[11] = '<button type="button" class="btn btn-light mr-2"><i class="fa fa-eye" /></button>'
        student[12] = '<button type="button" class="btn btn-light mr-2"><i class="fa fa-comment" /></button>'
      }
      this.options.data = dataQualifications.performanceList
      this.options.includeHeadersOnDownload = dataQualifications.options.includeHeadersOnDownload
      this.periodFinalDate = dataQualifications.period.finalDate
      this.options.operator = dataQualifications.options.operator
      this.options.automatic = dataQualifications.options.automatic
      this.options.nestedHeaders = dataQualifications.options.nestedHeaders
      this.options.columns = dataQualifications.options.columns
      this.lastUpdated = dataQualifications.lastUpdated
      document.getElementById('spreadsheetPerformance').innerHTML = ''
      const jExcelObj = jexcel(this.$refs.spreadsheetPerformance, this.options)
      this.jExcelObj = Object.assign({}, jExcelObj)
    },
    clean() {
      this.search = ''
    },
    beforeChange(instance, cell, x, y, value) { // Validations
      if (value === '') {
        return value
      }
      if (isNaN(parseInt(value)) || !isFinite(value)) {
        return ''
      }
      if (value === '0' || value === '0.0') {
        return ''
      }
      value = parseInt(value)
      if (value <= 0) {
        return ''
      }
      return value
    },
    afterchanges(a, rowData) {
      if (this.teacherEditableView) {
        if (this.autoSave) {
          clearTimeout(this.typingTimer)
          this.typingTimer = setTimeout(() => { this.saveGradesPerformance() }, 500)
        } else {
          this.isRecentChanges = true
        }
      }
    },
    saveGradesPerformance() {
      if (this.teacherEditableView) {
        const indicators = this.options.data
        const indicatorsToSend = []
        for (const indicator of indicators) {
          indicatorsToSend.push(indicator.slice(0, 11))
        }
        apiClient.patch('performance-indicators/classes/' + this.idClass, { indicatorsToReceive: indicatorsToSend, isElective: this.isElective }).then(response => {
          if (!this.autoSave) {
            this.isRecentChanges = false
            Toast.fire({
              icon: 'success',
              title: 'Cambios guardados.',
            })
          }
          this.lastUpdated = response.data.lastUpdated
          this.$emit('updatedAt', this.lastUpdated)
        }).catch(error => {
          this.$notification.error({
            message: 'Ooops ocurrió un error',
            description: showErrorMessage(error),
          })
        })
      } else {
        this.$notification.warning({
          message: 'Modificación no permitida',
          description: 'Directores de grupos, no pueden modificar indicadores.',
        })
      }
    },
    saveObservation() {
      if (this.teacherEditableView) {
        apiClient.patch('performance-indicators/classes/' + this.idClass + '/observations', { idStudent: this.rowModal.data[0], observation: this.observation, isElective: this.isElective }).then(response => {
          Toast.fire({
            icon: 'success',
            title: 'Observación guardada.',
          })
          for (const student of this.dataInfo.observationList) {
            if (student[0] === this.rowModal.data[0]) {
              student[1] = this.observation
            }
          }
          this.$bvModal.hide('observation')
        }).catch(error => {
          this.$notification.error({
            message: 'Ooops ocurrió un error',
            description: showErrorMessage(error),
          })
        })
      } else {
        this.$notification.warning({
          message: 'Modificación no permitida',
          description: 'Directores de grupos, no pueden realizar observaciones.',
        })
      }
    },
    recieveIndicator(indicator, type) {
      if (type === 0) {
        let index = null
        let canAdd = true
        switch (indicator.type) {
          case '1':
            for (let i = 5; i < 8; i++) {
              if (this.rowModal.data[i] === indicator.id) {
                canAdd = false
              } else if (this.rowModal.data[i] === '' && index === null) {
                index = i
              }
            }
            break
          case '2':
            for (let i = 2; i < 5; i++) {
              if (this.rowModal.data[i] === indicator.id) {
                canAdd = false
              } else if (this.rowModal.data[i] === '' && index === null) {
                index = i
              }
            }
            break
          case '3':
            for (let i = 8; i < 11; i++) {
              if (this.rowModal.data[i] === indicator.id) {
                canAdd = false
              } else if (this.rowModal.data[i] === '' && index === null) {
                index = i
              }
            }
            break
        }
        if (index !== null && canAdd) {
          this.jExcelObj.setValueFromCoords(index, this.rowModal.row, indicator.id)
          Toast.fire({
            icon: 'success',
            title: 'El indicador se ha guardado con éxito',
          })
        } else if (index !== null && !canAdd) {
          Toast.fire({
            icon: 'warning',
            title: 'El indicador ya se encuentra seleccionado',
          })
        } else {
          Toast.fire({
            icon: 'info',
            title: 'No hay casillas disponibles',
          })
        }
      } else if (type === 1) {
        const maxlength = this.jExcelObj.getData(false).length
        this.inconsistences = []
        for (let k = 0; k < maxlength; k++) {
          const rowData = this.jExcelObj.getRowData(k)
          let index = null
          let canAdd = true
          switch (indicator.type) {
            case '1':
              for (let i = 5; i < 8; i++) {
                if (rowData[i] === indicator.id) {
                  canAdd = false
                } else if (rowData[i] === '' && index === null) {
                  index = i
                }
              }
              break
            case '2':
              for (let i = 2; i < 5; i++) {
                if (rowData[i] === indicator.id) {
                  canAdd = false
                } else if (rowData[i] === '' && index === null) {
                  index = i
                }
              }
              break
            case '3':
              for (let i = 8; i < 11; i++) {
                if (rowData[i] === indicator.id) {
                  canAdd = false
                } else if (rowData[i] === '' && index === null) {
                  index = i
                }
              }
              break
          }
          if (index !== null && canAdd) {
            this.jExcelObj.setValueFromCoords(index, k, indicator.id)
          } else if (index !== null && !canAdd) {
            this.inconsistences.push([rowData[0], rowData[1], 'Ya tiene este indicador'])
          } else {
            this.inconsistences.push([rowData[0], rowData[1], 'No tiene espacio para el indicador'])
          }
        }
        if (this.inconsistences.length > 0) {
          this.$bvModal.show('inconsistences')
        } else {
          Toast.fire({
            icon: 'success',
            title: 'Indicadores asignados correctamente',
          })
        }
      }
    },
  },
}
</script>
